import { render, staticRenderFns } from "./MailLogList.vue?vue&type=template&id=2403fcbe"
import script from "./MailLogList.vue?vue&type=script&lang=js"
export * from "./MailLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports